module.exports = __webpack_public_path__ + "img/2.c1d65137.gif";